(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6215],{

/***/ 83614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-limited-or-closed-account/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-14",
      tag: "Mercari",
      title: "Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As one of the well-known online marketplaces in the US, Mercari allows you to sell all kinds of brand new, secondhand, and even vintage clothing and items. Creating an account here is simple and takes only a few clicks. But what happens when suddenly, you get locked out of certain features, or worse, your account gets terminated? From selling prohibited items to detecting suspicious activity, here are the common reasons to look out for and how you can get your account back."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Limited and Closed Accounts"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Having a limited account on Mercari simply means you cannot navigate the online marketplace either as a buyer or seller. There are certain features you can't access or utilize as you are banned from doing so."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When you have a closed or terminated profile, you cannot access your Mercari account at all. You are unable to buy and sell or make any kind of transactions.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Of course, no one would want this to happen to them. It is such an inconvenience, especially to sellers, as you are not allowed to transact with clients and close sales--your ultimate goal for joining the marketplace in the first place."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why It Happens"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A few factors cause an account to be limited or terminated."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["First, you have to keep in mind all the prohibited items from being sold on Mercari. Whether this is intentional or not, at the platform's discretion, Mercari will remove these items, and your account will be suspended or terminated. This is why it is crucial to read up on the prohibited goods that violate the platform's terms of service.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Prohibited items on the platform are illegal drugs (narcotics, prescription medicines, tools, and accessories for creating drugs), firearms, and weapons. Stolen goods and other items you currently don't possess on-hand, FDA-restricted items, alcohol, tobacco products, digital items, and safety-hazard items are also included in the list."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This list is not exhaustive, so you should check out Mercari's page for the entire list."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Second, take note of all user activity that goes against Mercari's policies. These include any fraudulent activity, product, and transaction that can tarnish Mercari's image and violate a bank's or a government's terms and regulations, which negatively impact and cause harm and liabilities."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari's Prohibited Conduct Policy also states a number of illegal activities such as using the platform that violates any local, national, or international laws; posting anything deceptive, hateful, and inappropriate; and interfering with Mercari's operations like uploading malicious software and collecting information of a third party without any prior consent."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Also, take note of other activities, such as having multiple accounts, impersonating a business, and creating a new account to avoid or bypass a previous termination."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Make sure that you are completely honest about your products for your listings. Don't list anything that's not in your possession, and don't use or grab photos from the internet and claim them as your items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Trading or exchanging, including international shipping and shipping from a manufacturer, should be avoided for transactions. Unauthorized returns are also something to avoid. So, make sure you go through the process to avoid getting banned."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Lastly, any kind of threat, harassment, spamming, indecent behavior, copyright infringement, and fraudulent activity causes the limitation or termination of Mercari accounts."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Other Violations"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sometimes, there are cases when an account gets hacked or has an unusual transaction activity. Mercari can detect this, especially when a bank alerts the platform that an activity can be a case of identity theft. Mercari then instantly limits your account. This protects you and your money while they do a thorough investigation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You need not worry as this will take little time, especially if it is not something major. You only need to be patient as the investigation and account limitations are for your safety as well."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In other instances, seller profiles may show high volumes of cancellations, chargebacks, and/or returns. When this is the case, Mercari also limits your account so they can review your behavior or user activity. This is to protect not only you but also other Mercari users."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Of course, no potential client would want to transact with a problematic seller, whether intentional or not. You would want to keep your profile and overall image as clean, credible, and trustworthy as possible."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What To Do During Suspension"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari needs you to verify your identity when creating an account, such as collecting tax information. Aside from complying with legal obligations, this is to maintain Mercari as a safe online marketplace."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When your account gets limited, you will receive a notification and email about the details on the app. This includes the period your account is under observation and/or if you need to take action."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you need to take action, you must contact Mercari and select the Account Type and reason for contacting. There are a number of choices you can choose from under the limited account reason. You can also explain your appeal in detail and provide images when necessary."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once you have filled up the \"Still Need Help\" form, you have to wait for your request to be attended to patiently. Remember that Mercari receives a high volume of queries and concerns, so you need to wait for yours to be addressed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Keep Closing Sales in Other Ways"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "No seller would want to have their account limited or completely terminated. This is why you have to be careful in all your activities, transactions, listings, and other ways you navigate Mercari."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "However, if your account is limited, especially when this is not intentional, this is where cross-posting comes in handy. If you can't post to Mercari, you still want to make sales while the investigation is ongoing, so posting on other marketplaces is one great way to do so."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you post your listings on Mercari, you can subscribe to an app like OneShop that lets you cross-list to other top marketplaces such as Poshmark, Mercari, and soon, on eBay and Facebook Marketplace."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop does everything for you: from cross-promoting to gain buyer exposure, relisting to bump your items on shoppers' feed, to delisting when an item gets sold on a particular platform. You can also track your sales and review overall seller performance within a few clicks."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can now get a 7-day trial for free, so it is possible to quickly learn all the great features of OneShop without paying for anything upfront. You can ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/",
          children: "subscribe here"
        }), " today!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-limited-or-closed-account.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Familiarize yourself with how you can avoid your Mercari account from getting limited or closed. Learn the factors that cause this and how you can retrieve your account if it happens."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-limited-or-closed-account"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-limited-or-closed-account"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Familiarize yourself with how you can avoid your Mercari account from getting limited or closed. Learn the factors that cause this and how you can retrieve your account if it happens."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "April 14th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "April 14th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 27316:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-limited-or-closed-account",
      function () {
        return __webpack_require__(83614);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(27316); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);